<div *ngIf="visible"
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-slate-900/60 px-4 backdrop-blur-[2px] modal-backdrop">
  <div
    class="flex max-h-[92vh] w-[95vw] max-w-6xl min-h-[550px] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl modal-panel"
    (click)="$event.stopPropagation()">
    <div *ngIf="chargementEnCours" class="flex flex-1 flex-col items-center justify-center gap-3 py-16">
      <svg class="h-8 w-8 animate-spin text-blue-600" viewBox="0 0 24 24" fill="none">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>

        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
      </svg>

      <p class="text-[13px] text-slate-500">
        Chargement du détail…
      </p>
    </div>
    <div *ngIf="!chargementEnCours && erreur"
      class="flex flex-1 flex-col items-center justify-center gap-3 py-16 text-center">
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" class="text-red-500">
        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />

        <path d="M12 8v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />

        <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
      </svg>

      <p class="text-[14px] font-semibold text-red-700">
        Impossible de charger le détail de ce certificat.
      </p>

      <button type="button"
        class="mt-1 rounded-md bg-slate-800 px-4 py-2 text-[13px] font-semibold text-white hover:bg-slate-900"
        (click)="fermerModal()">
        Fermer
      </button>
    </div>
    <ng-container *ngIf="!chargementEnCours && !erreur && certificat">
      <div class="relative flex flex-none items-center bg-blue-800 px-6 py-5 mb-3">
        <div class="flex min-w-0 flex-1 items-center gap-3.5 pr-10">

          <span
            class="flex h-11 w-1 flex-none items-center justify-center rounded-xl bg-white/10 text-slate-200 ring-1 ring-white/20">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" stroke-linejoin="round">
              <path
                d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .4 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />

              <path d="M9 18h6" />
              <path d="M10 22h4" />
              <path d="M12 2v2" />
            </svg>
          </span>

          <h3 class="min-w-0 flex-1 break-words text-[17px] font-bold leading-snug text-white">
            {{ certificat.certificateName }}
          </h3>
        </div>
        <button type="button"
          class="absolute right-5 top-1/2 flex h-8 w-1 -translate-y-1/2 items-center justify-center rounded-lg  bg-white/10  text-slate-300 transition hover:bg-white/10 hover:text-white"
          (click)="fermerModal()" aria-label="Fermer">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
          </svg>
        </button>
      </div>
      <div class="min-w-0 flex-1 overflow-y-auto overflow-x-hidden">
        <div class="grid grid-cols-2 gap-3 px-6 pt-5 md:grid-cols-4">
          <div class="rounded-xl border border-slate-100 bg-slate-50/80 p-3.5">
            <div class="flex items-center justify-between">
              <span class="block text-[11px] font-medium text-slate-500">
                Total enrôlés Moodle
              </span>

              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-slate-500">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="1.8"
                  stroke-linecap="round" />

                <circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8" />

                <path d="M23 21v-2a4 4 0 0 0-3-3.87" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />

                <path d="M16 3.13a4 4 0 0 1 0 7.75" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
            </div>

            <strong class="mt-1 block text-xl font-bold text-slate-800">
              {{ certificat.totalEnrolled | number }}
            </strong>
          </div>
          <div class="rounded-xl border border-slate-100 bg-emerald-50/60 p-3.5">
            <div class="flex items-center justify-between">
              <span class="block text-[11px] font-medium text-emerald-700">
                Connectés
              </span>

              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-emerald-600">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8" />

                <path d="M8 12l3 3 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>

            <strong class="mt-1 block text-xl font-bold text-emerald-900">
              {{ certificat.totalConnected | number }}
            </strong>
          </div>
          <div class="rounded-xl border border-slate-100 bg-red-50/60 p-3.5">
            <div class="flex items-center justify-between">
              <span class="block text-[11px] font-medium text-red-700">
                Jamais connectés
              </span>

              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="text-red-500">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8" />

                <path d="M15 9l-6 6M9 9l6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>
            </div>

            <strong class="mt-1 block text-xl font-bold text-red-900">
              {{ certificat.totalNeverConnected | number }}
            </strong>
          </div>
          <div class="rounded-xl border border-slate-100 bg-slate-50 p-3.5">
            <span class="block text-[11px] font-medium text-slate-500">
              Répartition M / F
            </span>

            <div class="mt-1.5 flex h-2 w-full overflow-hidden rounded-full bg-slate-200">
              <div class="h-full bg-blue-500" [style.width.%]="
                  (certificat.totalMale /
                    (certificat.totalMale + certificat.totalFemale || 1)) * 100
                "></div>

              <div class="h-full bg-pink-400" [style.width.%]="
                  (certificat.totalFemale /
                    (certificat.totalMale + certificat.totalFemale || 1)) * 100
                "></div>
            </div>

            <div class="mt-1.5 flex items-center justify-between text-[11.5px] text-slate-500">
              <span>
                {{ certificat.totalMale }} M
              </span>

              <span>
                {{ certificat.totalFemale }} F
              </span>
            </div>
          </div>
        </div>
        <div class="mx-6 mt-4 rounded-xl border border-slate-100 p-3.5">
          <div class="mb-1.5 flex items-center justify-between text-[12px] font-medium text-slate-500">
            <span>
              Taux de connexion
            </span>

            <span class="font-semibold text-slate-700">
              {{ tauxConnexion }}%
            </span>
          </div>

          <div class="h-2 w-full overflow-hidden rounded-full bg-slate-100">
            <div class="h-full rounded-full bg-emerald-500 transition-all" [style.width.%]="tauxConnexion"></div>
          </div>
        </div>
        <div class="mx-6 mt-5 flex flex-nowrap items-center justify-between gap-2">
          <h4 class="flex-none whitespace-nowrap pt-1.5 text-[13.5px] font-bold text-slate-700">
            Apprenants

            <span class="ml-1 font-normal text-slate-400">
              ({{ apprenantsFiltres.length }})
            </span>
          </h4>

          <div class="flex min-w-0 flex-1 flex-nowrap items-center justify-end gap-1.5">
            <div class="flex flex-none rounded-lg bg-slate-100 p-0.5 text-[11.5px] font-medium whitespace-nowrap">
              <button type="button" class="rounded-md px-2 py-1 transition" [ngClass]="
                  filtreStatut === 'tous'
                    ? 'bg-white text-slate-800 shadow-sm'
                    : 'text-slate-500 hover:text-slate-700'
                " (click)="changerFiltre('tous')">
                Tous
              </button>
              <button type="button" class="rounded-md px-2 py-1 transition" [ngClass]="
                  filtreStatut === 'connectes'
                    ? 'bg-white text-emerald-700 shadow-sm'
                    : 'text-slate-500 hover:text-slate-700'
                " (click)="changerFiltre('connectes')">
                Connectés
              </button>
              <button type="button" class="rounded-md px-2 py-1 transition" [ngClass]="
                  filtreStatut === 'jamaisConnectes'
                    ? 'bg-white text-red-700 shadow-sm'
                    : 'text-slate-500 hover:text-slate-700'
                " (click)="changerFiltre('jamaisConnectes')">
                Jamais connectés
              </button>
            </div>
            <div class="relative min-w-[110px] flex-1 max-w-[190px]">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                class="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400">
                <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="1.8" />

                <path d="M21 21l-3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
              </svg>

              <input type="text" [(ngModel)]="recherche" placeholder="Rechercher…"
                class="w-full rounded-lg border border-slate-200 bg-white py-1.5 pl-8 pr-3 text-[12.5px] text-slate-700 placeholder:text-slate-400 focus:border-slate-400 focus:outline-none" />
            </div>
            <button type="button" (click)="ouvrirModalMail()" *ngIf="apprenantsFiltres.length>0"
              class="inline-flex flex-none items-center gap-1.5 whitespace-nowrap rounded-lg bg-blue-600 px-3 py-1.5 text-[12.5px] font-medium text-white shadow-sm transition hover:bg-blue-700 active:scale-95">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16v16H4z" />
                <path d="M22 6l-10 7L2 6" />
              </svg>
              Envoyer un mail
            </button>
            <button type="button" (click)="exporterExcel()"
              class="inline-flex flex-none items-center gap-1.5 whitespace-nowrap rounded-lg bg-emerald-600 px-3 py-1.5 text-[12.5px] font-medium text-white shadow-sm transition hover:bg-emerald-700 active:scale-95">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />

                <polyline points="14 2 14 8 20 8" />

                <line x1="8" y1="13" x2="16" y2="13" />

                <line x1="8" y1="17" x2="16" y2="17" />

                <line x1="10" y1="9" x2="8" y2="9" />
              </svg>

              Exporter Excel
            </button>

            <button type="button" (click)="exporterEmailsEnEchec()"
              [disabled]="exportEchecsEnCours || progression < 100"
              class="inline-flex flex-none items-center gap-1.5 whitespace-nowrap whitespace-nowrap rounded-lg bg-amber-600 px-3 py-1.5 text-[12.5px] font-medium text-white shadow-sm transition hover:bg-amber-700 active:scale-95 disabled:cursor-not-allowed disabled:opacity-60">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>

              <span>{{ exportEchecsEnCours ? 'Téléchargement…' : 'Emails en échec' }}</span>

              <!-- % intégré DANS le bouton : n'ajoute aucun élément à la barre -->
              <span *ngIf="progression < 100"
                class="rounded-full bg-white/25 px-1.5 py-0.5 text-[11px] font-bold tabular-nums">
                {{ progression }}%
              </span>
            </button>

          </div>
        </div>
        <div class="mx-6 mb-6 mt-3 max-h-[48vh] overflow-y-auto overflow-x-hidden rounded-xl border border-slate-100">
          <table class="w-full table-fixed border-collapse text-[12.5px]">
            <thead>
              <tr class="sticky top-0 z-10 bg-slate-50">
                <th class="w-[39%] border-b border-slate-200 py-2.5 pl-3 pr-2 text-left font-semibold text-slate-500">
                  Apprenant
                </th>
                <th class="w-[25%] border-b border-slate-200 py-2.5 pr-2 text-left font-semibold text-slate-500">
                  Email
                </th>
                <th class="w-[11%] border-b border-slate-200 py-2.5 pr-2 text-center font-semibold text-slate-500">
                  Sexe
                </th>
                <th class="w-[25%] border-b border-slate-200 py-2.5 pr-3 text-center font-semibold text-slate-500">
                  Statut
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let l of apprenantsFiltres"
                class="border-b border-slate-100 last:border-b-0 hover:bg-slate-50">
                <td class="min-w-0 py-2 pl-3 pr-2">
                  <div class="flex min-w-0 items-center gap-2">
                    <span
                      class="flex h-7 w-2 flex-none items-center justify-center rounded-full bg-slate-100 text-[10.5px] font-semibold text-slate-500">
                      {{ (l.firstname || '?')[0] }}{{ (l.lastname || '')[0] }}
                    </span>

                    <span class="min-w-0 break-words font-medium text-slate-800">
                      {{ l.firstname }} {{ l.lastname }}
                    </span>
                  </div>
                </td>
                <td class="min-w-0 py-2 pr-2 text-slate-500">
                  <span class="block break-words">
                    {{ l.email }}
                  </span>
                </td>
                <td class="py-2 pr-2 text-center">
                  <span class="inline-block rounded px-1.5 py-0.5 text-[11px] font-medium" [ngClass]="
                      l.sexe === 'masculin'
                        ? 'bg-blue-50 text-blue-700'
                        : l.sexe === 'feminin'
                          ? 'bg-pink-50 text-pink-700'
                          : 'bg-slate-100 text-slate-500'
                    ">
                    {{
                    l.sexe === 'masculin'
                    ? 'M'
                    : l.sexe === 'feminin'
                    ? 'F'
                    : 'N/R'
                    }}
                  </span>
                </td>
                <td class="py-2 pr-3 text-center">
                  <span
                    class="inline-flex max-w-full items-center justify-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold"
                    [ngClass]="
                      l.neverConnected
                        ? 'bg-red-50 text-red-700'
                        : 'bg-emerald-50 text-emerald-700'
                    ">
                    <span class="h-1.5 w-1.5 flex-none rounded-full" [ngClass]="
                        l.neverConnected
                          ? 'bg-red-500'
                          : 'bg-emerald-500'
                      "></span>

                    {{
                    l.neverConnected
                    ? 'Jamais connecté'
                    : 'Connecté'
                    }}
                  </span>
                </td>
              </tr>
              <tr *ngIf="!apprenantsFiltres.length">
                <td colspan="4" class="py-10 text-center text-[12.5px] text-slate-400">
                  Aucun apprenant ne correspond à cette recherche.
                </td>
              </tr>

            </tbody>
          </table>
        </div>

      </div>
    </ng-container>

    <app-envoi-mail-modal [visible]="mailModalVisible" [nombreDestinataires]="apprenantsFiltres.length"
      [envoiEnCours]="mailEnvoiEnCours" [resultatEnvoi]="mailResultat" (fermer)="fermerModalMail()"
      (envoyer)="onEnvoyerMail($event)" (fermerResultat)="onFermerResultatMail()">
    </app-envoi-mail-modal>

  </div>
</div>